import { Injectable } from '@angular/core';
import { KPI } from '../api';


@Injectable()
export class BuildingsService {

  /**
   * Finds the perimeters linked to the building
   *
   * @param buildingId the building's id
   * @param perimeters the list of all the perimeters
   */
  public findBuildingPerimeters(buildingId: number, perimeters: KPI.Perimeter[]): KPI.Perimeter[] {
    for (const perimeter of perimeters) {
      if (perimeter.building_id === buildingId) {
        return [ perimeter ];
      }
      if (perimeter.sub_perimeters) {
        const matchingSubPerimeters = this.findBuildingPerimeters(buildingId, perimeter.sub_perimeters);
        if (matchingSubPerimeters.length > 0) {
          return [].concat([ perimeter ], matchingSubPerimeters);
        }
      }
    }
    return [];
  }
}
